import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { MinusCircleIcon } from '@phosphor-icons/react/MinusCircle';
import { PlusCircleIcon } from '@phosphor-icons/react/PlusCircle';

export const StyledRowContainer = styled(Grid)`
  flex-wrap: nowrap;
  align-items: center;
`;

export const StyledIconContainer = styled(Grid)`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const StyledRowTextContainer = styled(Grid)`
  & p {
    word-break: break-word;
    text-wrap: wrap;
  }
`;

export const StyledAddIcon = styled(PlusCircleIcon)`
  color: ${({ theme }) => theme.palette.success.main};
`;

export const StyledRemoveIcon = styled(MinusCircleIcon)`
  color: ${({ theme }) => theme.palette.error.main};
`;

export const StyledTagsSection = styled(Grid)`
  margin: ${({ theme }) => theme.spacing(1, 0)};
`;
